import { BUTTON } from "../Buttons/classnames";
// Option classnames

export var BASE_BOX = 'inline-flex flex-shrink-0 justify-between items-center w-full h-56 px-16';
export var OPTION_WRAPPER = 'inline-flex flex-col h-full w-full overflow-auto rounded-5';
export var OPTION = /*#__PURE__*/"".concat(BUTTON, " ").concat(BASE_BOX, " text-base-main bg-white hover:text-primary-main hover:bg-gray-lighter");
export var OPTION_DARK = /*#__PURE__*/"".concat(BUTTON, " ").concat(BASE_BOX, " text-gray-light bg-gray-main-dark-mode hover:text-white hover:bg-base-light-dark-mode");
export var OPTION_TRANSPARENCY = /*#__PURE__*/"".concat(BUTTON, " ").concat(BASE_BOX, " text-white hover:text-base-main hover:bg-white");
export var BACKGROUND_COLOR_CLASSNAMES = {
  light: 'bg-white',
  dark: 'bg-base-lighter-dark-mode',
  transparency: 'bg-base-main'
};